import { Viewport } from "pixi-viewport";
import type * as PIXI from "pixi.js";
import {
  VIEWPORT_INITIAL_OFFSET_X,
  VIEWPORT_INITIAL_OFFSET_Y,
  ZOOM_MAX_SCALE,
  ZOOM_MIN_SCALE
} from "./viewport.constants";
import { updateBackground } from "../background/background.utils";

let viewport: Viewport | null = null;

export const getViewport = () => {
  if (!viewport) {
    throw new Error("Viewport not initialized");
  } else {
    return viewport;
  }
};

export const isViewportInitialized = () => {
  return !!viewport;
};

const handleResize = () => {
  getViewport().resize(window.innerWidth, window.innerHeight);
  // redraw the background after resizing
  updateBackground();
};

export const enableViewportDrag = () => {
  getViewport().plugins.resume("drag");
};

export const disableViewportDrag = () => {
  getViewport().plugins.pause("drag");
};

export const getViewportZoomLevel = () => {
  if (!isViewportInitialized()) {
    return 1;
  }
  return getViewport().scale.x;
};

export const initializeViewport = (app: PIXI.Application) => {
  viewport = new Viewport({
    screenWidth: window.innerWidth,
    screenHeight: window.innerHeight,
    // This should be larger than the clamp boundaries defined in worldBoundary.ts
    // to ensure smooth scrolling and prevent viewport from getting stuck at edges
    worldWidth: 5000,
    worldHeight: 5000,
    disableOnContextMenu: true,
    // the interaction module is important for wheel to work properly when renderer.view is placed or scaled
    // interaction: app.renderer.plugins.interaction
    events: app.renderer.events
  });

  viewport.x = VIEWPORT_INITIAL_OFFSET_X;
  viewport.y = VIEWPORT_INITIAL_OFFSET_Y;

  window.addEventListener("resize", handleResize);

  /**
   * Initialize viewport plugins
   */
  viewport
    .drag({ clampWheel: false, mouseButtons: "middle-right" })
    .pinch()
    .wheel({
      smooth: 3,
      trackpadPinch: true
    })
    .decelerate({
      friction: 0.9
    })
    .clampZoom({
      minScale: ZOOM_MIN_SCALE,
      maxScale: ZOOM_MAX_SCALE
    });

  return {
    viewport,
    cleanup: () => {
      if (viewport) {
        viewport.removeAllListeners();
        viewport.destroy();
        viewport = null;
      }
      window.removeEventListener("resize", handleResize);
    }
  };
};
